import { ContactKindCard } from "@/routes/base-data/contacts/contact-kind/_components/contact-kind-card";
import { RltServiceContactKindMatchCard } from "@/routes/base-data/contacts/contact-kind/_components/rlt-service-contact-kind-match-card";
import { VbsServiceContactKindMatchCard } from "@/routes/base-data/contacts/contact-kind/_components/vbs-service-contact-kind-match-card";

export function ContactKindRoute() {
  return (
    <div>
      <ContactKindCard />
      <div className="mt-4 grid gap-4 xl:grid-cols-2">
        <VbsServiceContactKindMatchCard />
        <RltServiceContactKindMatchCard />
      </div>
    </div>
  );
}
